import { Row, Col, Divider } from "antd";
import BlackSLogo from "assets/Images/Header/BlackSLogo.svg";
import FullLogo from "assets/Images/Header/FullLogo.svg";
import Options from "./Components/Options/Options";
import CategoryIndex from "./Components/CategoryIndex";
import { Link } from "react-router-dom";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import MobileSearch from "./Components/Serach/MobileSearch";

const MobileIndex = () => {
  return (
    <>
      <div
        className=" 
      
      shadow-lg   "
      >
        <Row gutter={[0, 0]}>
          <Col
            className="!flex justify-between  !items-center !bg-[#FFF]  !py-2 
      !px-2 lg:!px-6 xxl:!px-16 "
            xs={24}
          >
            <Link to="/">
              <LazyLoadImage
                classNames="!w-[30px] !h-[30px]  !block md:!hidden"
                wrapperWidth="0"
                wrapperHeight="0"
                style={{ objectFit: "contain" }}
                src={BlackSLogo}
                alt="Sari ilanlar logosu"
              />
              <LazyLoadImage
                classNames="!hidden md:!block"
                wrapperWidth="200px"
                wrapperHeight="38px"
                style={{ objectFit: "contain" }}
                src={FullLogo}
                alt="Sari ilanlar logosu"
              />
            </Link>

            <CategoryIndex />
            <span className=" !flex items-center !pr-1">
              <MobileSearch />
            </span>
          </Col>

          <Col
            xs={24}
            className="!fixed !bottom-0 !left-0 !w-full !z-50 !border border-gray-100 
             !bg-white !shadow-xl !flex !items-center 
             !justify-between !py-2 !px-4"
          >
            <Options />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MobileIndex;
